
import { Grid, Grid2Props, styled } from '@mui/material';

const StyledGrid = styled(Grid)({
    marginBottom: 10
});

const KeyValueRow = (props: Grid2Props) => (
    <StyledGrid container>
        { props.children }
    </StyledGrid>
);

export default KeyValueRow;